import epoch from './epoch';

const cacheBust = (url) => {
	const newUrl = new URL(url);
	newUrl.searchParams.set('cb', epoch());
	return newUrl;
};

export default cacheBust;
